module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vnis"
  }, [_c('button', {
    class: _vm.buttonClass,
    on: {
      "click": _vm.decreaseNumber,
      "mousedown": function($event) {
        _vm.whileMouseDown(_vm.decreaseNumber)
      },
      "mouseup": _vm.clearTimer
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('input', {
    class: _vm.inputClass,
    attrs: {
      "type": "number",
      "min": _vm.min,
      "max": _vm.max,
      "debounce": "500"
    },
    domProps: {
      "value": _vm.numericValue
    },
    on: {
      "keypress": _vm.validateInput,
      "input": _vm.inputValue
    }
  }), _vm._v(" "), _c('button', {
    class: _vm.buttonClass,
    on: {
      "click": _vm.increaseNumber,
      "mousedown": function($event) {
        _vm.whileMouseDown(_vm.increaseNumber)
      },
      "mouseup": _vm.clearTimer
    }
  }, [_vm._v("+")])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-122462c4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-122462c4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NumberInputSpinner.vue
// module id = 2
// module chunks = 0